export default __webpack_public_path__ + "static/media/circleCross.88dbb0a7.svg";